import { lazy, Suspense } from "react";
import AppLayout from "../pages/Common/Layout";
import CommonLayout from "../pages/Common/CommonLayout";
import SegmentsLayout from "../layouts/Loyalty/Segment/SegmentLayout";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useMenuAccess } from "../contexts/MenuAccessContext";

const Dashboard = lazy(() => import("../pages/Loyalty/DashboardPage"));
const ProgramPage = lazy(() => import("../pages/Loyalty/ProgramPage"));
// import AnalyticsPage from "../pages/Loyalty/AnalyticsPage";
const ReportingPage = lazy(() => import("../pages/Loyalty/ReportingPage"));
const SegmentPage = lazy(() => import("../pages/Loyalty/Segments/SegmentPage"));
const SettingsPage = lazy(() => import("../pages/SettingsPage"));
const CouponsPage = lazy(() => import("../pages/Coupon/CouponsPage").then((m) => ({ default: m.CouponsPage })));
const CouponsCreatePage = lazy(() => import("../pages/Coupon/CouponsCreatePage").then((m) => ({ default: m.CouponsCreatePage })));
const LoyaltySettingsPage = lazy(() => import("../pages/Loyalty/LoyaltySettingsPage"));
const InventoryDashboard = lazy(() => import("../pages/Inventory/InventoryDashboard"));
const CreateSegmentPage = lazy(() => import("../pages/Loyalty/Segments/CreateSegmentPage"));
const VendorDetailsPage = lazy(() => import("../pages/PurchaseManagement/VendorDetailsPage"));
const VendorInvoicePage = lazy(() => import("../pages/PurchaseManagement/VendorInvoicePage"));
const ProductCatalogPage = lazy(() => import("../pages/PurchaseManagement/ProductCatalogPage"));
const RetailerProductCatalogPage = lazy(() => import("../pages/WholeSales/ProductCatalogPage"));
const ProductCatalogCreatePOPage = lazy(() => import("../pages/WholeSales/ProductCatalogCreatePOPage"));
const VendorDashboard = lazy(() => import("../pages/PurchaseManagement/VendorDashboardPage"));
const InventoryCreateOrEditPage = lazy(() => import("../pages/Inventory/InventoryCreateOrEditPage"));
const PurchaseManagementSettings = lazy(() => import("../pages/PurchaseManagement/PurcharseManagementSettings"));
const PurchaseManagementDashboard = lazy(() => import("../pages/PurchaseManagement/PurchaseManagementDashboard"));
const PurchaseManagementPurchaseOrdersPage = lazy(() => import("../pages/PurchaseManagement/PurchaseManagementPurchaseOrdersPage"));
const PurchaseManagementReconciliationPage = lazy(() => import("../pages/PurchaseManagement/PurchaseManagementReconciliationPage"));
const PurchaseManagementPODetailsPage = lazy(() => import("../pages/PurchaseManagement/PurchaseManagemenPODetailsPage"));
const PurchaseManagementReceiveShipmentPage = lazy(() => import("../pages/PurchaseManagement/PurchaseManagementReceiveShipmentPage"));
const VendorPurchaseOrderDetailsPage = lazy(() => import("../pages/PurchaseManagement/Vendors/VendorPurchaseOrderDetailsPage"));
const GeneratePOPage = lazy(() => import("../pages/PurchaseManagement/Vendors/GeneratePOPage"));
const RetailerGeneratePOPage = lazy(() => import("../pages/WholeSales/Retailer/GeneratePOPage"));
const PurchaseManagementInvoicesPage = lazy(() => import("../pages/PurchaseManagement/PurchaseManagementInvoicesPage"));
const InventoryItemsPage = lazy(() => import("../pages/Inventory/InventoryItemsPage"));
const InventoryReportsPage = lazy(() => import("../pages/Inventory/InventoryReportsPage"));
const InventoryBulkUpdatesPage = lazy(() => import("../pages/Inventory/InventoryBulkUpdatesPage"));
const SegmentUpdatePage = lazy(() => import("../pages/Loyalty/Segments/SegmentUpdatePage"));
const ScanDataDashboard = lazy(() => import("../pages/ScanData/ScanDataDashboard"));
const ScanDataStoreSettings = lazy(() => import("../pages/ScanData/ScanDataStoreSettings"));
const ScanDataHelp = lazy(() => import("../pages/ScanData/ScanDataHelp"));
const ScanDataReports = lazy(() => import("../pages/ScanData/ScanDataReports"));
const ScanDataRJRDiscounts = lazy(() => import("../pages/ScanData/ScanDataRJRDiscounts"));
const ScanDataAccounts = lazy(() => import("../pages/ScanData/ScanDataAccounts"));
const CustomersSegmentPage = lazy(() => import("../pages/Loyalty/Segments/CustomersSegementPage"));
const AutomationSegmentPage = lazy(() => import("../pages/Loyalty/Segments/AutomationSegmentPage"));
const InventoryBulkUpdatesViewPage = lazy(() => import("../pages/Inventory/InventoryBulkUpdatesViewPage"));
const InventoryBulkUpdateItemsPage = lazy(() => import("../pages/Inventory/InventoryBulkUpdateItemsPage"));
const CommunicationDashboard = lazy(() => import("../pages/Communication/CommunicationDashboard"));
const CommunicationAnalytics = lazy(() => import("../pages/Communication/CommunicationAnalytics"));
const CommunicationCampaigns = lazy(() => import("../pages/Communication/CommunicationCampaigns"));
const CommunicationNotifications = lazy(() => import("../pages/Communication/CommunicationNotifications"));
const InventoryAuditHistoryPage = lazy(() => import("../pages/Inventory/InventoryAuditHistoryPage"));
const InventoryAuditItemsPage = lazy(() => import("../pages/Inventory/InventoryAuditItemsPage"));
const CouponsDashboardPage = lazy(() => import("../pages/Coupon/CouponsDashboardPage").then((m) => ({ default: m.CouponsDashboardPage })));
const InventoryAuditNewPage = lazy(() => import("../pages/Inventory/InventoryAuditNewPage"));
const SendSMSPage = lazy(() => import("../layouts/Loyalty/Segment/SendSMSPage").then((m) => ({ default: m.SendSMSPage })));
const CouponsUpdatePage = lazy(() => import("../pages/Coupon/CouponsUpdatePage").then((m) => ({ default: m.CouponsUpdatePage })));
const CouponsDetailsPage = lazy(() => import("../pages/Coupon/CouponsDetailsPage").then((m) => ({ default: m.CouponsDetailsPage })));
const SalesDashboardPage = lazy(() => import("../pages/Sales/SalesDashboardPage"));
const SalesOnlineStorePage = lazy(() => import("../pages/Sales/SalesOnlineStorePage"));
const SalesReportsPage = lazy(() => import("../pages/Sales/SalesReportsPage"));
const SalesSettingsPage = lazy(() => import("../pages/Sales/SalesSettingsPage"));
const LotteryDashboardPage = lazy(() => import("../pages/Lottery/LotteryDashboardPage"));
const LotterySettingsPage = lazy(() => import("../pages/Lottery/LotterySettingsPage"));
const LotteryGeneralSettingsPage = lazy(() => import("../pages/Lottery/LotteryGeneralSettingsPage"));
const LotteryUserManagementPage = lazy(() => import("../pages/Lottery/LotteryUserManagementPage"));
const LotteryReportsPage = lazy(() => import("../pages/Lottery/LotteryReportsPage"));
const LotteryAuditPage = lazy(() => import("../pages/Lottery/LotteryAuditPage"));
const LotteryDailyClosingPage = lazy(() => import("../pages/Lottery/LotteryDailyClosingPage"));
const LotteryGameListPage = lazy(() => import("../pages/Lottery/Games/LotteryGameListPage"));
const LotteryGameCreatePage = lazy(() => import("../pages/Lottery/Games/LotteryGameCreatePage"));
const LotteryAuditCreatePage = lazy(() => import("../pages/Lottery/LotteryAuditCreatePage"));
const LotteryGameUpdatePage = lazy(() => import("../pages/Lottery/Games/LotteryGameUpdatePage"));
const LotteryGameInventoryPage = lazy(() => import("../pages/Lottery/Games/LotteryGameInventoryPage"));
const GiftCardDashboardPage = lazy(() => import("../pages/GiftCard/GiftCardDashboardPage"));
const GiftCardsPage = lazy(() => import("../pages/GiftCard/GiftCardsPage"));
const GiftCardDetailsPage = lazy(() => import("../pages/GiftCard/GiftCardDetailsPage"));
const GiftCardReportsPage = lazy(() => import("../pages/GiftCard/GiftCardReportsPage"));
const GiftCardTransactionReportPage = lazy(() => import("../pages/GiftCard/Reports/GiftCardTransactionReportPage"));
const GiftCardRedemptionReportPage = lazy(() => import("../pages/GiftCard/Reports/GiftCardRedemptionReportPage"));
const GiftCardBalanceReportPage = lazy(() => import("../pages/GiftCard/Reports/GiftCardBalanceReportPage"));
const GiftCardCardStatusReportPage = lazy(() => import("../pages/GiftCard/Reports/GiftCardCardStatusReportPage"));
const GiftCardSettingsPage = lazy(() => import("../pages/GiftCard/GiftCardSettingsPage"));

const A2ADashboardPage = lazy(() => import("../pages/WineSol/A2A/A2ADashboardPage"));

// import WebsitePage from "../pages/WineSol/Marketing/WebsitePage";
// import MarketingCommunicationPage from "../pages/WineSol/Marketing/CommunicationPage";
// import ContentPage from "../pages/WineSol/Marketing/ContentPage";
// import AdsAnalyticsPage from "../pages/WineSol/Marketing/AdsAnalyticsPage";
// import SMSPage from "../pages/WineSol/Marketing/SMSPage";
// import EmailPage from "../pages/WineSol/Marketing/EmailPage";
const WineSolSettingsPage = lazy(() => import("../pages/WineSol/Settings/SetttingsPage"));

const CustomerManagementPage = lazy(() => import("../pages/WineSol/LoyaltyWineSol/CustomerManagementPage"));
const UCPPage = lazy(() => import("../pages/WineSol/LoyaltyWineSol/UCPPage"));
const SegmentationWineSolPage = lazy(() => import("../pages/WineSol/LoyaltyWineSol/SegmentationPage"));
const AutomationWineSolPage = lazy(() => import("../pages/WineSol/LoyaltyWineSol/AutomationPage"));
const CouponsPromotionsPage = lazy(() => import("../pages/WineSol/LoyaltyWineSol/CouponsPromotionsPage"));

const EcommercePage = lazy(() => import("../pages/WineSol/SalesWineSol/EcommercePage"));
const ClubsSubscriptionsPage = lazy(() => import("../pages/WineSol/SalesWineSol/ClubsSubscriptionsPage"));
const CreateAutomationPage = lazy(() => import("../pages/Loyalty/Automations/CreateAutomationPage"));
const UpdateAutomationPage = lazy(() => import("../pages/Loyalty/Automations/UpdateAutomationPage"));
const AutomationPage = lazy(() => import("../pages/Loyalty/Automations/AutomationPage"));
const CustomerListPage = lazy(() => import("../pages/WineSol/CustomerManagement/CustomerListPage"));
const CustomerViewPage = lazy(() => import("../pages/WineSol/CustomerManagement/CustomerViewPage"));
const WebsitePage = lazy(() => import("../pages/WineSol/Marketing/WebsitePage"));
const MarketingCommunicationDashboard = lazy(() => import("../pages/WineSol/Marketing/CommunicationDashboard"));
const CommunicationSMSPage = lazy(() => import("../pages/WineSol/Marketing/CommunicationsSMSPage"));
const CommunicationEmailPage = lazy(() => import("../pages/WineSol/Marketing/CommunicationEmailPage"));
const ComposeSocialPostPage = lazy(() => import("../pages/WineSol/Marketing/ComposeSocialPostPage"));
const AnalyticsPage = lazy(() => import("../pages/WineSol/A2A/AnalyticsPage"));
const PricingPage = lazy(() => import("../pages/Pricing/PricingPage"));
const PricingCreatePage = lazy(() => import("../pages/Pricing/PricingCreatePage"));
const PricingEditPage = lazy(() => import("../pages/Pricing/PricingEditPage"));
const PricingViewPage = lazy(() => import("../pages/Pricing/PricingViewPage"));
const RetailerDashboardPage = lazy(() => import("../pages/WholeSales/RetailerDashboardPage"));
const WholeSalesManagementDashboard = lazy(() => import("../pages/WholeSales/WholeSalesManagementDashboard"));
const WholeSalesManagementInvoicesPage = lazy(() => import("../pages/WholeSales/WholeSalesManagementInvoicesPage"));
const RetailerInvoicePage = lazy(() => import("../pages/WholeSales/RetailerInvoicePage"));
const WholeSalesManagementSettings = lazy(() => import("../pages/WholeSales/WholeSalesManagementSettings"));
const RetailerDetailsPage = lazy(() => import("../pages/WholeSales/RetailerDetailsPage"));
const WholeSalesManagementPurchaseOrdersPage = lazy(() => import("../pages/WholeSales/WholeSalesManagementPurchaseOrdersPage"));
const WholeSalesManagementPODetailsPage = lazy(() => import("../pages/WholeSales/WholeSalesManagementPODetailsPage"));
const WholeSalesManagementReconciliationPage = lazy(() => import("../pages/WholeSales/WholeSalesManagementReconciliationPage"));
const WholeSalesManagementFinalizePage = lazy(() => import("../pages/WholeSales/WholeSalesManagementFinalizePage"));
const RetailerPurchaseOrderDetailsPage = lazy(() => import("../pages/WholeSales/Retailer/RetailerPurchaseOrderDetailsPage"));
const LotteryGameSalesReportDetailPage = lazy(() => import("../pages/Lottery/LotteryGameSalesReportDetailPage"));
const WholeSalesReportsPage = lazy(() => import("../pages/WholeSales/WholeSalesReportsPage"));
const SalesOrdersPage = lazy(() => import("../pages/Sales/SalesOrdersPage"));
const AddRetailerPage = lazy(() => import("../pages/WholeSales/AddRetailerPage"));
const InventoryAnalyticsPage = lazy(() => import("../pages/AnalyticsEngine/InventoryAnalyticsPage"));
const GenerateAIReportPage = lazy(() => import("../pages/AnalyticsEngine/GenerateAIReportPage"));
const ReportTemplatesPage = lazy(() => import("../pages/AnalyticsEngine/ReportTemplatesPage"));
const CreateOwnReportPage = lazy(() => import("../pages/AnalyticsEngine/CreateOwnReportPage"));
const EditAnalyticsReportPage = lazy(() => import("../pages/AnalyticsEngine/EditAnalyticsReportPage"));
const ViewAnalyticsReportPage = lazy(() => import("../pages/AnalyticsEngine/ViewAnalyticsReportPage"));
const KoronaOnboardPage = lazy(() => import("../pages/Partner/KoronaOnboardPage"));
const GiftCardWalletPage = lazy(() => import("../pages/GiftCard/GiftCardWalletPage"));

const allowedLocations = {
    "c39e45b7-74de-44a4-94ff-a2ddca88180a": ["loyalty", "communication", "promotions"],
    "e397f379-4b2e-4311-bccd-00e03bd40103": ["loyalty", "communication", "promotions"],
};

const WINE_SOL_LOCATION_ID = "7ab06ab8-214b-48b3-b569-02bd7b6c21a7";
const ROLLERS_WINE_SPIRITS_ID = "a40c5519-a76b-48f6-84f2-d510f8d8a5a5";

const getAccessibleLandingPath = ({ permissions, isRollersWineSpirits, isWineSolLocation, allowedTabs = [] }) => {
    if (isWineSolLocation) {
        return "/wine-sol/customers";
    }

    const modules = [
        { module: "loyalty", path: "/loyalty/dashboard", enabled: isRollersWineSpirits ? false : permissions?.loyalty },
        { module: "inventory", path: "/inventory/items", enabled: isRollersWineSpirits ? true : permissions?.inventory },
        { module: "promotions", path: "/promotions/dashboard", enabled: isRollersWineSpirits ? false : permissions?.coupons },
        { module: "gift-kard", path: "/gift-kard/dashboard", enabled: isRollersWineSpirits ? true : (permissions?.giftCard ?? true) },
        { module: "purchase-management", path: "/purchase-management/vendors", enabled: isRollersWineSpirits ? true : permissions?.purchase },
        { module: "whole-sales", path: "/whole-sales/retailers", enabled: isRollersWineSpirits ? true : permissions?.distribution },
        { module: "communication", path: "/communication/dashboard", enabled: isRollersWineSpirits ? false : permissions?.communication },
        { module: "scan-data", path: "/scan-data/dashboard", enabled: isRollersWineSpirits ? false : permissions?.scanData },
        { module: "account", path: "/account", enabled: isRollersWineSpirits ? true : permissions?.settings },
        { module: "sales", path: "/sales/dashboard", enabled: isRollersWineSpirits ? false : permissions?.sales },
        { module: "lottery", path: "/lottery/dashboard", enabled: isRollersWineSpirits ? false : permissions?.lottery },
        { module: "analytics", path: "/analytics", enabled: isRollersWineSpirits ? false : Boolean(permissions?.analyticsEngine) },
    ];

    const scopedModules = allowedTabs?.length ? modules.filter((entry) => allowedTabs.includes(entry.module)) : modules;
    return (
        scopedModules.find((entry) => entry.enabled)?.path ||
        modules.find((entry) => entry.enabled)?.path ||
        (isRollersWineSpirits ? "/inventory/items" : "/loyalty/dashboard")
    );
};

const InitialLandingRedirect = () => {
    const { permissions, loading } = useMenuAccess();
    const location = useLocation();
    const query = location.search || "";
    const locationUid = new URLSearchParams(query).get("id");

    if (loading || !permissions) {
        return <div />;
    }

    const isRollersWineSpirits = locationUid === ROLLERS_WINE_SPIRITS_ID;
    const isWineSolLocation = locationUid === WINE_SOL_LOCATION_ID;
    const allowedTabs = allowedLocations[locationUid] || [];

    const fallbackPath = getAccessibleLandingPath({
        permissions,
        isRollersWineSpirits,
        isWineSolLocation,
        allowedTabs,
    });

    return <Navigate to={`${fallbackPath}${query}`} replace />;
};

const NavigateToAccessibleRoute = () => {
    const { permissions, loading } = useMenuAccess();
    const location = useLocation();
    const query = location.search || "";
    const locationUid = new URLSearchParams(query).get("id");

    if (loading || !permissions) {
        return <div />;
    }

    const isRollersWineSpirits = locationUid === ROLLERS_WINE_SPIRITS_ID;
    const isWineSolLocation = locationUid === WINE_SOL_LOCATION_ID;
    const allowedTabs = allowedLocations[locationUid] || [];

    const fallbackPath = getAccessibleLandingPath({
        permissions,
        isRollersWineSpirits,
        isWineSolLocation,
        allowedTabs,
    });

    return <Navigate to={`${fallbackPath}${query}`} replace />;
};

const RedirectPreservingSearch = ({ to }) => {
    const location = useLocation();
    return <Navigate to={`${to}${location.search || ""}`} replace />;
};

const AppRoutes = () => {

    return (
        <Router>
            <Suspense fallback={<div className="flex items-center justify-center" style={{ minHeight: "40vh" }}><i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }} /></div>}>
            <Routes>
                <Route path="/partner/korona/onboard" element={<KoronaOnboardPage />} />
                <Route path="/gift-kard/wallet/:securityKey" element={<GiftCardWalletPage />} />
                <Route path="/" element={<AppLayout />}>
                    <Route
                        index
                        path=""
                        element={<InitialLandingRedirect />}
                    />
                    <Route path="loyalty" element={<CommonLayout />}>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="program" element={<ProgramPage />} />
                        <Route path="settings" element={<LoyaltySettingsPage />} />
                        {/* <Route path="analytics" element={<AnalyticsPage />} /> */}
                        <Route path="reporting" element={<ReportingPage />} />
                        <Route path="segments" element={<SegmentsLayout />} >
                            <Route index element={<SegmentPage />} />
                            <Route path="create" element={<CreateSegmentPage />} />
                            <Route path=":id/update" element={<SegmentUpdatePage />} />
                            <Route path=":id/send-sms" element={<SendSMSPage />} />
                            <Route path=":id/customers" element={<CustomersSegmentPage />} />
                            <Route path=":id/automations" element={<AutomationSegmentPage />} />
                        </Route>
                        <Route
                            path="automations"
                            element={<CommonLayout />} >
                            <Route
                                index
                                element={<AutomationPage />} />
                            <Route
                                path="create"
                                element={<CreateAutomationPage />} />
                            <Route
                                path=":automationId/edit"
                                element={<UpdateAutomationPage />} />
                        </Route>
                    </Route>
                    <Route path="pricing" element={<PricingPage />} />
                    <Route path="pricing/create" element={<PricingCreatePage />} />
                    <Route path="pricing/edit/:id" element={<PricingEditPage />} />
                    <Route path="pricing/view/:id" element={<PricingViewPage />} />
                    <Route path="sales" element={<CommonLayout />}>
                        <Route path="dashboard" element={<SalesDashboardPage />} />
                        <Route path="online-store" element={<SalesOnlineStorePage />} />
                        {/* <Route path="reports" element={<SalesReportsPage />} /> */}
                        <Route path="orders" element={<SalesOrdersPage />} />
                        <Route path="settings" element={<SalesSettingsPage />} />
                    </Route>

                    <Route path="analytics" element={<CommonLayout />}>
                        <Route index element={<InventoryAnalyticsPage />} />
                        <Route path="generate-ai" element={<GenerateAIReportPage />} />
                        <Route path="templates" element={<ReportTemplatesPage />} />
                        <Route path="build-own" element={<RedirectPreservingSearch to="/analytics/reports/build-own" />} />
                        <Route path="build-own/reports/build-own" element={<RedirectPreservingSearch to="/analytics/reports/build-own" />} />
                        <Route path="reports/build-own" element={<CreateOwnReportPage />} />
                        <Route path="reports/:reportId" element={<ViewAnalyticsReportPage />} />
                        <Route path="reports/:reportId/edit" element={<EditAnalyticsReportPage />} />
                        <Route path="inventory" element={<Navigate to="/analytics" replace />} />
                        <Route path="inventory/generate-ai" element={<Navigate to="/analytics/generate-ai" replace />} />
                        <Route path="inventory/templates" element={<Navigate to="/analytics/templates" replace />} />
                        <Route path="inventory/build-own" element={<RedirectPreservingSearch to="/analytics/reports/build-own" />} />
                    </Route>

                    <Route path="wine-sol" element={<CommonLayout />}>

                        {/* <Route path="dashboard">
                            <Route path="a2a" element={<A2ADashboardPage />} />
                        </Route> */}
                        <Route path="customers">
                            <Route index element={<CustomerListPage />} />
                            <Route path=":id" element={<CustomerViewPage />} />
                        </Route>
                        <Route path="segments" element={<SegmentsLayout />} >
                            <Route index element={<SegmentPage />} />
                            <Route path="create" element={<CreateSegmentPage />} />
                            <Route path=":id/update" element={<SegmentUpdatePage />} />
                            <Route path=":id/send-sms" element={<SendSMSPage />} />
                            <Route path=":id/customers" element={<CustomersSegmentPage />} />
                            <Route path=":id/automations" element={<AutomationSegmentPage />} />
                        </Route>
                        <Route
                            path="automations"
                            element={<CommonLayout />} >
                            <Route
                                index
                                element={<AutomationPage />} />
                            <Route
                                path="create"
                                element={<CreateAutomationPage />} />
                            <Route
                                path=":automationId/edit"
                                element={<UpdateAutomationPage />} />
                        </Route>

                        <Route path="marketing">
                            <Route path="website" element={<WebsitePage />} />
                            <Route path="dashboard" element={<A2ADashboardPage />} />
                            <Route path="analytics" element={<AnalyticsPage />} />
                            <Route
                                path="communication"
                                element={<CommonLayout />}>
                                <Route
                                    path="dashboard"
                                    element={<MarketingCommunicationDashboard />}
                                />
                                <Route path="send-sms" element={<CommunicationSMSPage />} />
                                <Route path="send-email" element={<CommunicationEmailPage />} />
                                <Route path="post" element={<ComposeSocialPostPage />} />

                                <Route
                                    path="analytics"
                                    element={<CommunicationAnalytics />}
                                />
                                <Route
                                    path="campaigns/*"
                                    element={<CommunicationCampaigns />}
                                />

                            </Route>
                        </Route>

                        <Route path="loyalty">
                            <Route path="customers" element={<CustomerManagementPage />} />
                            <Route path="ucp" element={<UCPPage />} />
                            <Route path="segments" element={<SegmentsLayout />} >
                                <Route index element={<SegmentPage />} />
                                <Route path="create" element={<CreateSegmentPage />} />
                                <Route path=":id/update" element={<SegmentUpdatePage />} />
                                <Route path=":id/send-sms" element={<SendSMSPage />} />
                                <Route path=":id/customers" element={<CustomersSegmentPage />} />
                                <Route path=":id/automations" element={<AutomationSegmentPage />} />
                            </Route>
                            <Route
                                path="automations"
                                element={<CommonLayout />} >
                                <Route
                                    index
                                    element={<AutomationPage />} />
                                <Route
                                    path="create"
                                    element={<CreateAutomationPage />} />
                                <Route
                                    path=":automationId/edit"
                                    element={<UpdateAutomationPage />} />
                            </Route>
                            <Route path="coupons" element={<CouponsPromotionsPage />} />
                        </Route>

                        <Route path="sales">
                            <Route path="ecommerce" element={<EcommercePage />} />
                            <Route path="clubs" element={<ClubsSubscriptionsPage />} />
                        </Route>

                        <Route path="settings" element={<WineSolSettingsPage />} />

                    </Route>

                    <Route path="lottery" element={<CommonLayout />}>
                        <Route path="dashboard" element={<LotteryDashboardPage />} />
                        <Route path="games" element={<CommonLayout />}>
                            <Route index element={<LotteryGameListPage />} />
                            <Route path="create" element={<LotteryGameCreatePage />} />
                            <Route path=":id/sales" element={<LotteryGameSalesReportDetailPage />} />
                            <Route path=":id/update" element={<LotteryGameUpdatePage />} />
                            <Route path=":id/inventory" element={<LotteryGameInventoryPage />} />
                        </Route>
                        <Route path="daily-closing" element={<LotteryDailyClosingPage />} />
                        {/* <Route path="receive-inventory" element={<CommonLayout />}>
                            <Route index element={<LotteryReceiveInventoryPage />} />
                            <Route path="create" element={<LotteryReceiveInventoryCreatePage />} />
                        </Route> */}
                        <Route path="audit" element={<CommonLayout />}>
                            <Route index element={<LotteryAuditPage />} />
                            <Route path="create" element={<LotteryAuditCreatePage />} />
                        </Route>
                        <Route path="reports" element={<LotteryReportsPage />} />
                        <Route path="settings" element={<LotterySettingsPage />}>
                            <Route index element={<LotteryGeneralSettingsPage />} />
                            <Route path="user-management" element={<LotteryUserManagementPage />} />
                        </Route>
                    </Route>

                    <Route path="account" element={<SettingsPage />} />

                    <Route
                        path="inventory"
                        element={<CommonLayout />}>
                        <Route
                            path="dashboard"
                            element={<InventoryDashboard />}
                        />
                        <Route
                            path="items"
                            element={<InventoryItemsPage />}
                        />
                        <Route
                            path="bulk-updates"
                            element={<InventoryBulkUpdatesPage />}
                        />
                        <Route
                            path="bulk-updates/:id"
                            element={<InventoryBulkUpdatesViewPage />}
                        />
                        <Route
                            path="bulk-updates/create"
                            element={<InventoryBulkUpdateItemsPage />}
                        />
                        <Route
                            path="audit"
                            element={<InventoryAuditHistoryPage />}
                        />
                        <Route
                            path="audit/new"
                            element={<InventoryAuditNewPage />}
                        />
                        <Route
                            path="audit/:id"
                            element={<InventoryAuditItemsPage />}
                        />
                        {/* <Route 
                            path="reports" 
                            element={<InventoryReportsPage />} 
                        /> */}
                        <Route
                            path="new"
                            element={<InventoryCreateOrEditPage />}
                        />
                        <Route
                            path=":itemId/edit"
                            element={<InventoryCreateOrEditPage />}
                        />
                    </Route>
                    <Route
                        path="promotions"
                        element={<CommonLayout />}>
                        <Route
                            path="dashboard"
                            element={<CouponsDashboardPage />}
                        />
                        <Route
                            path="coupons"
                            element={<CouponsPage />}
                        />
                        <Route
                            path="coupons/create"
                            element={<CouponsCreatePage />}
                        />
                        <Route
                            path="coupons/:couponId/update"
                            element={<CouponsUpdatePage />}
                        />
                        <Route
                            path="coupons/:couponId"
                            element={<CouponsDetailsPage />}
                        />
                    </Route>
                    <Route path="gift-kard" element={<CommonLayout />}>
                        <Route index element={<RedirectPreservingSearch to="dashboard" />} />
                        <Route path="dashboard" element={<GiftCardDashboardPage />} />
                        <Route path="cards" element={<GiftCardsPage />} />
                        <Route path="cards/:cardId" element={<GiftCardDetailsPage />} />
                        <Route path="reports" element={<GiftCardReportsPage />}>
                            <Route index element={<RedirectPreservingSearch to="transactions" />} />
                            <Route path="transactions" element={<GiftCardTransactionReportPage />} />
                            <Route path="redemption" element={<GiftCardRedemptionReportPage />} />
                            <Route path="balance" element={<GiftCardBalanceReportPage />} />
                            <Route path="card-status" element={<GiftCardCardStatusReportPage />} />
                        </Route>
                        <Route path="settings" element={<GiftCardSettingsPage />} />
                    </Route>
                    <Route
                        path="purchase-management"
                        element={<CommonLayout />}>
                        <Route
                            path="vendors"
                            element={<VendorDashboard />}
                        />
                        <Route
                            path="dashboard"
                            element={<PurchaseManagementDashboard />}
                        />
                        <Route
                            path="product-catalogs"
                            element={<ProductCatalogPage />}
                        />
                        <Route
                            path="invoices"
                            element={<PurchaseManagementInvoicesPage />}
                        />
                        <Route
                            path="invoices/:invoiceId"
                            element={<VendorInvoicePage />}
                        />
                        <Route
                            path="settings"
                            element={<PurchaseManagementSettings />}
                        />
                        <Route
                            path="vendors/:vendorId"
                            element={<VendorDetailsPage />}
                        />
                        <Route
                            path="vendors/:vendorId/generate-po"
                            element={<GeneratePOPage />}
                        />
                        <Route
                            path="purchase-orders"
                            element={<PurchaseManagementPurchaseOrdersPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId"
                            element={<PurchaseManagementPODetailsPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId/reconcile"
                            element={<PurchaseManagementReconciliationPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId/receive-shipment"
                            element={<PurchaseManagementReceiveShipmentPage />}
                        />
                        <Route
                            path="vendors/:vendorId/invoices/:invoiceId"
                            element={<VendorInvoicePage />}
                        />
                        {/* <Route 
                            path="vendors/:vendorId/purchase-orders/:purchaseOrderId" 
                            element={<VendorPurchaseOrderDetailsPage />} 
                        /> */}
                        <Route
                            path="vendors/:vendorId/purchase-orders/:purchaseOrderId"
                            element={<PurchaseManagementPODetailsPage />}
                        />
                    </Route>
                    <Route
                        path="whole-sales"
                        element={<CommonLayout />}>
                        <Route
                            path="retailers"
                            element={<RetailerDashboardPage />}
                        />
                        <Route
                            path="retailers/new"
                            element={<AddRetailerPage />}
                        />
                        {/* <Route 
                            path="dashboard" 
                            element={<WholeSalesManagementDashboard />} 
                        /> */}
                        <Route
                            path="product-catalogs"
                            element={<RetailerProductCatalogPage />}
                        />
                        <Route
                            path="price-engine"
                            element={<Navigate to="/pricing" replace />}
                        />
                        <Route
                            path="invoices"
                            element={<WholeSalesManagementInvoicesPage />}
                        />
                        <Route
                            path="invoices/:invoiceId"
                            element={<RetailerInvoicePage />}
                        />
                        <Route
                            path="settings"
                            element={<WholeSalesManagementSettings />}
                        />
                        {/* <Route 
                            path="reports" 
                            element={<WholeSalesReportsPage />}
                        /> */}
                        <Route
                            path="retailers/:retailerId"
                            element={<RetailerDetailsPage />}
                        />
                        <Route
                            path="retailers/:retailerId/generate-po"
                            element={<RetailerGeneratePOPage />}
                        />
                        <Route
                            path="purchase-orders"
                            element={<WholeSalesManagementPurchaseOrdersPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId"
                            element={<WholeSalesManagementPODetailsPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId/reconcile"
                            element={<WholeSalesManagementReconciliationPage />}
                        />
                        <Route
                            path="purchase-orders/:purchaseOrderId/finalize"
                            element={<WholeSalesManagementFinalizePage />}
                        />
                        <Route
                            path="retailers/:retailerId/invoices/:invoiceId"
                            element={<RetailerInvoicePage />}
                        />
                        <Route
                            path="retailers/:retailerId/purchase-orders/:purchaseOrderId"
                            element={<WholeSalesManagementPODetailsPage />}
                        />
                        {/* <Route 
                            path="retailers/:retailerId/purchase-orders/:purchaseOrderId" 
                            element={<RetailerPurchaseOrderDetailsPage />} 
                        /> */}
                    </Route>
                    <Route
                        path="product-catalogs/create-po"
                        element={<ProductCatalogCreatePOPage />}
                    />
                    <Route
                        path="distribution/*"
                        element={<Navigate to="/whole-sales/retailers" replace />}
                    />
                    <Route
                        path="communication"
                        element={<CommonLayout />}>
                        <Route
                            path="dashboard"
                            element={<CommunicationDashboard />}
                        />
                        <Route
                            path="analytics"
                            element={<CommunicationAnalytics />}
                        />
                        <Route
                            path="campaigns/*"
                            element={<CommunicationCampaigns />}
                        />
                        <Route
                            path="notifications/*"
                            element={<CommunicationNotifications />}
                        />
                    </Route>
                    <Route
                        path="scan-data"
                        element={<CommonLayout />}>
                        <Route
                            index
                            element={<ScanDataDashboard />}
                        />
                        <Route
                            path="dashboard"
                            element={<ScanDataDashboard />}
                        />
                        <Route
                            path="rjr-discounts"
                            element={<ScanDataRJRDiscounts />}
                        />
                        <Route
                            path="accounts"
                            element={<ScanDataAccounts />}
                        />
                        <Route
                            path="reports"
                            element={<ScanDataReports />}
                        />
                        <Route
                            path="store-settings"
                            element={<ScanDataStoreSettings />}
                        />
                        <Route
                            path="help"
                            element={<ScanDataHelp />}
                        />
                    </Route>

                    <Route path="*" element={<NavigateToAccessibleRoute />} />

                </Route>
            </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoutes;
